export default {
  name: "YsTableButton",
  functional: true,
  props: {
    render: Function,
    type: String,
    size: {
      type: String,
      default: "small",
    },
    icon: String,
    nativeType: {
      type: String,
      default: "button",
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
  },
  render: (createElement, context) => {
    const { render, ...params } = context.props;
    return render(createElement, params);
  },
};



// WEBPACK FOOTER //
// ./src/components/YsForm/YsTableButton.js